import React from 'react';
import { Section } from './Section';
import { CheckIcon, XIcon } from 'lucide-react';
export function Audience() {
  return <Section bg="navy" data-id="element-15">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-12" data-id="element-16">
        {/* For You */}
        <div className="bg-navy-light p-5 md:p-10 rounded-2xl md:rounded-3xl border-t-4 border-t-green-500 border-x border-b border-white/5" data-id="element-17">
          <h3 className="text-xl md:text-3xl font-bold mb-5 md:mb-8 text-white" data-id="element-18">
            Esto ES Para Ti Si...
          </h3>
          <ul className="space-y-4 md:space-y-6" data-id="element-19">
            {['Padres de familia ejecutivos con hijos pequeños que quieren garantizar su universidad.', 'Directivos con excedentes de flujo mensual de $20,000 MXN en adelante.', 'Personas que buscan certeza absoluta y no quieren "apostar" su retiro en la bolsa o criptos.'].map((text, i) => <li key={i} className="flex items-start gap-3 md:gap-4" data-id="element-20">
                <div className="mt-0.5 bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-21">
                  <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-green-400" data-id="element-22" />
                </div>
                <span className="text-gray-light leading-relaxed text-sm md:text-base" data-id="element-23">
                  {text}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-navy-light p-5 md:p-10 rounded-2xl md:rounded-3xl border-t-4 border-t-red-500 border-x border-b border-white/5" data-id="element-24">
          <h3 className="text-xl md:text-3xl font-bold mb-5 md:mb-8 text-white" data-id="element-25">
            Esto NO Es Para Ti Si...
          </h3>
          <ul className="space-y-4 md:space-y-6" data-id="element-26">
            {['Gente que busca "hacerse rico rápido" con inversiones de alto riesgo.', 'Quienes confían 100% en que el gobierno les dará una pensión digna.'].map((text, i) => <li key={i} className="flex items-start gap-3 md:gap-4" data-id="element-27">
                <div className="mt-0.5 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-28">
                  <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-400" data-id="element-29" />
                </div>
                <span className="text-gray-light leading-relaxed text-sm md:text-base" data-id="element-30">
                  {text}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}